import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import Toasted from 'vue-toasted';
// import VueAnimate from 'vue-animate-scroll';
// import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
import 'moment/locale/uk'
import 'moment/locale/ru'



//use
Vue.use(Toasted, {
  duration: 3000
});
// Vue.use(VueAnimate);
Vue.use(VueTheMask);
// Vue.use(VueFacebookPixel)
